export const paginationSuccessHandler = ({ data }) => {
	const totalRows = data.data.length && data.data[0].totalRows
	return {
		rows: data.data,
		totalRows: (totalRows === undefined ? data.data.length : totalRows) || 0
	}
}

export const paginationErrorHandler = () => ({ rows: [], totalRows: 0 })
